import React from 'react';
import { TaskCard as ConnectedTaskCard } from 'shared/components/connected/task-card';
import {
  SortableContainer,
  SortableContainerProps,
} from 'shared/components/ui/sortable-container';
import { DraggableOptions } from 'shared/types/draggable-types';

export type TaskCardProps = React.ComponentProps<typeof ConnectedTaskCard> & {
  hasDnd?: boolean;
  preventDnd?: boolean;
};

const allDraggableOptions = Object.values(DraggableOptions);

export const TaskCard: React.FC<TaskCardProps> = ({
  task,
  hasDnd,
  preventDnd,
  ...rest
}) => {
  const Container = hasDnd ? SortableContainer : React.Fragment;
  const containerProps = (
    hasDnd
      ? {
          id: task.id,
          type: DraggableOptions.Task,
          cantInteractWithTypes: preventDnd
            ? allDraggableOptions
            : [
                DraggableOptions.LifeArea,
                DraggableOptions.Goal,
                DraggableOptions.GoalSection,
              ],
        }
      : {}
  ) as SortableContainerProps;

  return (
    <Container {...containerProps}>
      <ConnectedTaskCard task={task} {...rest} />
    </Container>
  );
};
